import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'
import vuetify from '@/plugins/vuetify';

export default {
  namespaced: true,
  state: {
    loginCapa: false,
    datosUsuarioCapa: '',
  },

  mutations: {
    LOGEADO(state, value) {
      state.loginCapa = value
    },
    DATOS_USUARIO(state, datosUsuarioCapa) {
      state.datosUsuarioCapa = datosUsuarioCapa
    },

    SALIR(state) {
      state.loginCapa = false
      state.datosUsuarioCapa = ''
    }
  },

  actions: {
    guardarInfo({ commit, dispatch }, usuario) {
      commit('DATOS_USUARIO', usuario)
      commit('LOGEADO', true)
      if (usuario && usuario.accessToken) {
        localStorage.setItem('accessToken', usuario.accessToken)
        localStorage.setItem('tlaKey', usuario.accessToken)
      }
    },

    salirLogin({ commit }) {
      commit('SALIR')
      localStorage.removeItem('accessToken')
      localStorage.removeItem('tlaKey')
    },
  },

  getters: {
    getLogeadoCapa(state) {
      return state.loginCapa
    },

    getUsuarioCapa(state) {
      return state.datosUsuarioCapa
    },
  }
}